import * as React from "react";
import PropTypes from "prop-types";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function CustomDialogTitle({ handleClose, title }) {
  return (
    <DialogTitle
      sx={{
        fontSize: 20,
        textTransform: "uppercase",
        color: "white",
        py: 1,
        px: 3
      }}
      className="bg-primary"
    >
      {title}
      {handleClose ? (
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 4,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

CustomDialogTitle.propTypes = {
  title: PropTypes.string,
  handleClose: PropTypes.func
};
